import { render } from "./about-me.vue?vue&type=template&id=26ebeb36&ts=true"
import script from "./about-me.vue?vue&type=script&lang=ts"
export * from "./about-me.vue?vue&type=script&lang=ts"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__